export async function loadLineShape(engine, refresh = true) {
    const { LineDrawer } = await import("./LineDrawer.js");
    await engine.addShape("line", new LineDrawer(), refresh);
}
